import { useEffect, useState } from "react";
import { useCalendarStore } from "../../../hooks";
import { MainButton, SecondaryButton, TertiaryButton } from "../../ui";
import { ScheduledPatientModal } from "../modals";

export const ScheduledPatientCard = ({
  patientSurgery,
  event,
  isProcedure,
}) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    selectedPatientSurgery,
    isLoading,

    // Methods
    startSetSelectedPatientSurgery,
    startResetSelectedPatientSurgery,
    startAttendanceProcedure,
    startAttendanceAssessment,
  } = useCalendarStore();

  // States ------------------------------------------------//
  const [isScheduledPatientModal, setIsScheduledPatientModal] = useState(false);
  const [scheduleEventId, setScheduleEventId] = useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const onScheduledPatientModal = ({ patientSurgery, scheduleEventId }) => {
    startSetSelectedPatientSurgery(patientSurgery);
    setScheduleEventId(scheduleEventId);
    setIsScheduledPatientModal(true);
  };

  const onAttendanceProcedure = (attended) => {
    startAttendanceProcedure({
      attended,
      scheduleEventId: event.id,
    });
  };

  const onAttendanceAssessment = (attended) => {
    startAttendanceAssessment({
      attended,
      scheduleEventId: event.id,
    });
  };

  const onAttendance = ({ state, value }) => {
    if (state === "SCHEDULED_ASSESSMENT_FINAL") {
      onAttendanceAssessment(value);
      return;
    }
    onAttendanceProcedure(value);
    return;
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!isScheduledPatientModal && selectedPatientSurgery && scheduleEventId) {
      startResetSelectedPatientSurgery();
      setScheduleEventId(null);
    }
  }, [
    isScheduledPatientModal,
    selectedPatientSurgery,
    startResetSelectedPatientSurgery,
    scheduleEventId,
  ]);

  // useEffect(() => {
  //   console.log("patientSurgery", patientSurgery);
  // }, [patientSurgery]);

  return (
    <>
      <div className="card border">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <h6>Paciente agendado:</h6>
            <div className="d-grid gap-2">
              <TertiaryButton
                className={`fw-bold`}
                type="button"
                onClick={() =>
                  onScheduledPatientModal({
                    patientSurgery,
                    scheduleEventId: event.id,
                  })
                }
              >
                Revisar
              </TertiaryButton>
              {event.attended === null &&
                (isProcedure ||
                  patientSurgery.state === "SCHEDULED_ASSESSMENT_FINAL") && (
                  <>
                    <SecondaryButton
                      className={`fw-bold`}
                      type="button"
                      onClick={() =>
                        onAttendance({
                          state: patientSurgery.state,
                          value: false,
                        })
                      }
                      disabled={isLoading}
                    >
                      No asistió
                    </SecondaryButton>
                    <MainButton
                      className={`fw-bold`}
                      type="button"
                      onClick={() =>
                        onAttendance({
                          state: patientSurgery.state,
                          value: true,
                        })
                      }
                      disabled={isLoading}
                    >
                      Asitió
                    </MainButton>
                  </>
                )}
            </div>
          </div>
          {event.attended === false && (
            <h6 className="mb-0 mt-2">
              {`El paciente no asistió ${
                isProcedure ? "al procedimiento" : "a la valoración"
              }`}
            </h6>
          )}
          {event.attended === true && (
            <h6 className="mb-0 mt-2">{`El paciente asistió ${
              isProcedure ? "al procedimiento" : "a la valoración"
            }`}</h6>
          )}
        </div>
      </div>

      <ScheduledPatientModal
        isOpen={isScheduledPatientModal}
        setIsOpen={setIsScheduledPatientModal}
        scheduleEventId={scheduleEventId}
      />
    </>
  );
};
